import { configureStore } from '@reduxjs/toolkit';
import bricksReducer from './slices/bricksSlice';
import configurationReducer from './slices/configurationSlice';
import wallManagerReducer from './slices/wallManagerSlice';

export const store = configureStore({
  reducer: {
    bricks: bricksReducer,
    configuration: configurationReducer,
    wallManager: wallManagerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['wallManager/setContext'],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.ctx', 'payload.img'],
        // Ignore these paths in the state
        ignoredPaths: ['wallManager.ctx'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;